import { keepPreviousData, QueryKey, useQuery } from '@tanstack/react-query';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { diContainer } from 'src/inversify.config';
import AddressesRepository from 'src/features/addresses/data/AddressesRepository';
import { Session, UserDetails } from 'src/types/common';

const addressesRepository =
  diContainer.get<AddressesRepository>(AddressesRepository);

export default function useAddressList() {
  const { user, session } = useAuthContext();
  const userId = user?.pk;
  const accessToken = session?.accessToken;

  const query = useQuery({
    queryKey: ['addresses', user, session],
    queryFn: () =>
      addressesRepository.getUserAddresses({
        userId: userId as number,
        accessToken: accessToken as string,
      }),
    enabled: !!userId && !!accessToken,
    placeholderData: keepPreviousData,
  });

  return {
    ...query,
    addresses: query.data ?? [],
    mainAddress: query.data?.find((address) => address.is_main),
  };
}

useAddressList.getQueryKey = (
  params?: {
    user?: UserDetails;
    session?: Session;
  },
  exact: boolean = false
): QueryKey => {
  if (!params || !exact) {
    return ['addresses'];
  }
  const { user, session } = params;

  return ['addresses', user, session];
};
